/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-unused-styles */
import React, { useMemo } from 'react';
import { View, StyleSheet, TouchableOpacity, Platform } from 'react-native';
import QText from './QText';
import { useTheme } from 'react-native-paper';
import Constants from 'expo-constants';
import RefreshIcon from './../components/Icons/RefreshIcon';
import SupportIcon from './../components/Icons/SupportIcon';
import NotificationsIcon from './../components/Icons/NotificationsIcon';
import BackArrowIcon from './Icons/BackArrowIcon';

const Header = ({
  title,
  isShowBack,
  onBackPress,
  refreshPage,
  onNotification,
  onSupport,
  onAddUser,
  addUserText,
}) => {
  const theme = useTheme();
  const styles = useMemo(() => createStyles(theme), [theme]);
  return (
    <>
      <View style={styles.headerContainer}>
        <View style={styles.statusBar}></View>
        <View style={styles.inlineBlocks}>
          <View style={{ width: '70%', flexDirection: 'row' }}>
            <>
              {isShowBack && (
                <TouchableOpacity
                  onPress={onBackPress}
                  style={{ width: 30 }}
                  accessible={true}
                  accessibilityLabel={`back_button`}
                >
                  <BackArrowIcon color={theme.colors.secondaryText} />
                </TouchableOpacity>
              )}
              {title && <QText style={styles.titleText}>{title}</QText>}
            </>
          </View>
          <View
            style={{
              width: '30%',
              flexDirection: 'row',
              justifyContent: 'flex-end',
            }}
          >
            {onSupport && (
              <TouchableOpacity onPress={onSupport}>
                <SupportIcon color={theme.colors.secondaryText} />
              </TouchableOpacity>
            )}

            {onAddUser && (
              <TouchableOpacity
                onPress={onAddUser}
                style={{
                  marginLeft: 15,
                  backgroundColor: theme.colors.blueColor,
                  paddingHorizontal: 8,
                  paddingVertical: 4,
                  borderRadius: 4,
                }}
              >
                <QText style={{ color: theme.colors.whiteTxt, fontSize: 12 }}>
                  {addUserText || '+ Add User'}
                </QText>
              </TouchableOpacity>
            )}

            {refreshPage && (
              <TouchableOpacity
                onPress={refreshPage}
                style={{ marginLeft: 15 }}
              >
                <RefreshIcon color={theme.colors.secondaryText} />
              </TouchableOpacity>
            )}
            {onNotification && (
              <TouchableOpacity
                style={{ marginLeft: 15 }}
                onPress={onNotification}
              >
                <NotificationsIcon color={theme.colors.secondaryText} />
              </TouchableOpacity>
            )}
          </View>
        </View>
      </View>
    </>
  );
};
const createStyles = (theme) =>
  StyleSheet.create({
    headerContainer: {
      // marginTop: Platform.OS === 'web' ? 20 : Constants.statusBarHeight,
      backgroundColor: theme.colors.background,
    },
    inlineBlocks: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: 15,
      paddingVertical: 10,
    },
    titleText: {
      color: theme.colors.secondaryText,
      fontSize: 16,
      // fontWeight: 600
    },
    statusBar: {
      height: Platform.OS === 'web' ? 10 : Constants.statusBarHeight,
      backgroundColor: theme.colors.background,
    },
  });
export default Header;
